@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivergroups
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.models.DriverGroupPurpose

class DriverGroupDto(
    val id: KmmLong?,
    val name: String,
    @Suppress("NON_EXPORTABLE_TYPE") val purpose: DtoName<DriverGroupPurpose>,
    val createdOn: DateTimeDto?
)